import React, { useState, useEffect } from "react"
import { Container, Col, Row } from "react-bootstrap"
import { SidemenuComponent } from "../../Components/Admin/Sidemenu"
import Adminmenucontainer from "../../Components/Admin/Adminmenucontainer"
import AdminMobilemenucontainer from "../../Components/Admin/ProductsMobileView"
const AdminDeleteorEdit = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Perform an initial check
    handleResize()

    // Listen for resize events
    window.addEventListener("resize", handleResize)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  return (
    <Container fluid>
      <Row>
        <Col
          lg="10"
          sm="12"
          className="px-0"
          style={{ marginLeft: isMobile ? "0" : "13%" }}
        >
          {isMobile ? <AdminMobilemenucontainer /> : <Adminmenucontainer />}
        </Col>
      </Row>
    </Container>
  )
}
export default AdminDeleteorEdit
